import { iife, Maybe } from '@crocodille/common';
import { useRouter } from 'next/router';
import React from 'react';
import { useTranslation } from 'react-i18next';

import onlyPickupEnImage from '../../../../public/only-pickup/only_pickup-en.png';
import onlyPickupMobileEnImage from '../../../../public/only-pickup/only_pickup-mobile-en.png';
import onlyPickupMobileImage from '../../../../public/only-pickup/only_pickup-mobile.png';
import onlyPickupImage from '../../../../public/only-pickup/only_pickup.png';
import { useMedia } from '../../../hooks/use-media';
import Image from '../../elements/image/image';
import styles from './product-only-pickup.module.scss';

export interface ProductOnlyPickupProps {
  readonly isOnlyPickup?: Maybe<boolean>;
  readonly forceMobile?: boolean;
}

/**
 * A card displaying product information in product listing.
 */
const ProductOnlyPickup: React.FC<
  React.PropsWithChildren<ProductOnlyPickupProps>
> = ({ isOnlyPickup = false, forceMobile = false }) => {
  const { t } = useTranslation();
  const { locale } = useRouter();

  const isMobile = useMedia('layout-with-drawer', false);

  const onlyPickupImg = iife(() => {
    if (isMobile || forceMobile) {
      if (locale === 'cs') {
        return onlyPickupMobileImage;
      } else {
        return onlyPickupMobileEnImage;
      }
    } else {
      if (locale === 'cs') {
        return onlyPickupImage;
      } else {
        return onlyPickupEnImage;
      }
    }
  });

  return isOnlyPickup ? (
    <div className={styles.imageContainer}>
      <Image
        className={styles.image}
        src={onlyPickupImg}
        alt={t('cart.only_pickup')}
        layout="fill"
      ></Image>
    </div>
  ) : null;
};

export default ProductOnlyPickup;
